import { useState, useEffect, useContext } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import Login from "./login/Login";
import Signup from "./SignUp";
import ForgetPass from "./ForgetPass";
import LoginBanner from "./login/LoginBanner";
import Register from "./login/Register";
import ValetLogin from "./valetParking/ValetLogin";
import RegisterUAEPass from "./login/RegisterUAEPass";
import OtpForLogin from "./login/OtpForLogin";
import Language from "./common/Language";
import { useTranslation } from "react-i18next";
import AuthContext from "../store/auth-context";

function Home(props: any) {
  const authCtx = useContext(AuthContext);
  const location = useLocation();
  const brandName = localStorage.getItem("brandName");
  const [showLogo, setShowLogo] = useState(true);
  const [t] = useTranslation();
  const [showLanguagebutton, setShowLanguageButton] = useState<boolean>(true);
  const [brandLogo, setBrandLogo] = useState<string>("");

  const url = window.location.pathname;

  useEffect(() => {
    let screenName = url.split("/home/").pop();
    if (screenName === "login") {
      setShowLanguageButton(true);
    } else {
      setShowLanguageButton(false);
    }
  }, [url]);

  useEffect(() => {
    if (
      location.pathname &&
      location.pathname.toLowerCase().indexOf("sign-up") > -1
    ) {
      setShowLogo(false);
    } else {
      setShowLogo(true);
    }
  }, [location]);

  useEffect(() => {
    if (brandName === "burjeel") {
      setBrandLogo(
        authCtx.selectedLanguage === "en"
          ? "/assets/images/burjeel-logo-EN.png"
          : "/assets/images/burjeel-logo-AR.png"
      );
    } else {
      setBrandLogo(props.logo);
    }
  }, [props.logo]);

  return (
    <>
      <div className="vh-100 container-fluid overflow-hidden">
        <div className="row align-items-center">
          <LoginBanner />
          <div className="login-content bg-white shadow vh-100 position-relative overflow-auto primary-scroll p-0 py-4">
            {/* <div className="col-xl-4 col-lg-5 col-md-6 bg-white shadow shadow-md-none vh-100 p-4 p-sm-5 position-relative overflow-auto primary-scroll"> */}
            <div className="login-content-body">
              <div className="d-flex align-items-center w-100">
                <img
                  src={brandLogo}
                  alt="logo"
                  className={showLogo ? "h-80p" : "d-none"}
                />
                {brandName === "burjeel" && showLanguagebutton && (
                  <div className="ms-auto mt-4">
                    <Language />
                  </div>
                )}
              </div>
              <Switch>
                <Route path="/home/sign-up" component={Signup}>
                  <Signup />
                </Route>
                <Route path="/home/login" component={Login}>
                  <Login />
                </Route>
                <Route path="/home/register" component={Register}>
                  <Register />
                </Route>
                <Route path="/home/UAEregister" component={RegisterUAEPass}>
                  <RegisterUAEPass />
                </Route>
                <Route path="/home/forgotpassword" component={ForgetPass}>
                  <ForgetPass />
                </Route>
                <Route path="/home/otpforlogin" component={OtpForLogin}>
                  <OtpForLogin />
                </Route>
              </Switch>

              <div className="fs-12 d-flex w-100 left-0 mt-5">
                <div className="mt-1">
                  © {t("All Rights Reserved")} | {t(props.brand)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
